import CurrentLink from 'app/dodones/shared/CurrentLink'
import TodayLink from 'app/dodones/shared/TodayLink'
import HeaderContext from 'app/HeaderContext'

export default ({ onNav }) => {
  const { contextualMenu: ContextualMenu } = useContext(HeaderContext)

  return (
    <div className="fcol flex-1 gap-2">
      <div className="fcol flex-1 gap-2">
        <TodayLink className="text-xl" onNav={onNav} query="?tab=today" />
        <CurrentLink className="text-xl" onNav={onNav} />
        <Link className="text-xl" to={'/dodones/days'} onClick={onNav}>
          Previous Days
        </Link>
        {!ContextualMenu ? null : (
          <>
            <div className="flex-1"></div>
            <ContextualMenu onNav={onNav} />
          </>
        )}
      </div>
      <div className="text-sm text-gray-500"> {API_URL} </div>
    </div>
  )
}
